/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from '@/axios.js'
import _ from 'lodash'
// import Vue from 'vue'
/* eslint-disable */
export default {
  addCourse({ commit }, obj) {
    return new Promise((resolve, reject) => {
      const course = new FormData()
      course.append('title', obj.title)
      course.append('cid', obj.cid)
      course.append('description', obj.description)
      course.append('duration', obj.duration)
      course.append('isEnabled', obj.isEnabled)
      course.append('price', obj.price)
      course.append('file', obj.file)

      axios
        .post('courses/add', course)
        .then((response) => {
          // console.log('course creted', response.data.data)
          commit('ADD_COURSE', Object.assign(response.data.data))
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchCourses({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get('/courses/all')
        .then((response) => {
          // console.log('all courses from db', response.data.data)
          commit('SET_COURSES', response.data.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  updateCourse({ dispatch }, obj) {
    return new Promise((resolve, reject) => {
      const course = new FormData()
      course.append('title', obj.title)
      course.append('cid', obj.cid)
      course.append('description', obj.description)
      course.append('duration', obj.duration)
      course.append('isEnabled', obj.isEnabled)
      course.append('price', obj.price)
      course.append('file', obj.file)
      axios
        .put(`courses/update/${obj._id}`, course)
        .then((response) => {
          // console.log('updated course from db', response.data.data)
          // commit('UPDATE_COURSE', response.data.data)
          dispatch('fetchCourses')
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  removeCourse({ commit }, courseId) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`courses/remove/${courseId}`)
        .then((response) => {
          commit('REMOVE_COURSE', courseId)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  //Lessons
  addLesson({ dispatch }, obj) {
    return new Promise((resolve, reject) => {
      const lesson = new FormData()
      lesson.append('courseId', obj.courseId)
      lesson.append('title', obj.title)
      lesson.append('description', obj.description)
      lesson.append('moduleName', obj.moduleName)
      lesson.append('startTime', obj.startTime)
      lesson.append('videoUrl', obj.videoUrl)
      lesson.append('path', obj.path)
      lesson.append('isEnabled', obj.isEnabled)
      if (obj.notes) {
        lesson.append('notes', obj.notes)
      }
      if (obj.docs) {
        _.forEach(obj.docs, (doc) => {
          lesson.append('docs', doc)
        })
      }
      if (!obj.isProcessed) {
        // console.log('sending new video')
        lesson.append('videoName', obj.videoName)
        lesson.append('videoDescription', obj.videoDescription)
      } else {
        lesson.append('isProcessed', obj.isProcessed)
      }

      axios
        .post('courses/lessons/add', lesson)
        .then((response) => {
          // console.log('lesson created', response.data.data)
          // commit('ADD_LESSON', Object.assign(response.data.data))
          dispatch('fetchModules', response.data.data.courseId)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchLessons({ commit }, { courseId, module }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/courses/admin/lessons/all/${courseId}`)
        .then((response) => {
          const dbModuleData = response.data.data
          // console.log('moduledata', dbModuleData)
          var lessons = []
          dbModuleData.forEach((m) => {
            // console.log('moduleName from table line 37', typeof(m._id.module), typeof(module))
            if (m._id.module === module) {
              lessons = [...m.lessonList]
              console.log('lessons in action', lessons)
            }
            // return lessons
          })
          commit('SET_LESSONS', lessons)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  // fetchLessons({ commit }, moduleName) {
  //   commit('SET_LESSONS', moduleName)
  // },
  updateLesson({ dispatch }, obj) {
    return new Promise((resolve, reject) => {
      const lesson = new FormData()
      lesson.append('id', obj.id)
      lesson.append('courseId', obj.courseId)
      lesson.append('title', obj.title)
      lesson.append('description', obj.description)
      lesson.append('moduleName', obj.moduleName)
      lesson.append('startTime', obj.startTime)
      lesson.append('videoUrl', obj.videoUrl)
      lesson.append('path', obj.path)
      lesson.append('isEnabled', obj.isEnabled)
      // if (obj.isProcessed) {
      //   console.log('isProcessed', obj.isProcessed)
      //   lesson.append('isProcessed', obj.isProcessed)
      // }
      if (!obj.isProcessed) {
        lesson.append('videoName', obj.videoName)
        lesson.append('videoDescription', obj.videoDescription)
      } else {
        lesson.append('isProcessed', obj.isProcessed)
      }
      if (obj.notes) {
        lesson.append('notes', obj.notes)
      }
      if (obj.docs) {
        _.forEach(obj.docs, (doc) => {
          lesson.append('docs', doc)
        })
      }
      if (obj.oldDocs) {
        _.forEach(obj.oldDocs, (doc) => {
          lesson.append('oldDocs', JSON.stringify(doc))
          // console.log('esixting urls stringified')
        })
      }

      axios
        .put(`courses/lessons/update/${obj.id}`, lesson)
        .then((response) => {
          // commit('UPDATE_LESSON', obj)
          dispatch('fetchLessons', {
            courseId: obj.courseId,
            module: obj.moduleName
          })
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  removeLesson({ commit }, lesson) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`courses/lessons/remove/${lesson.id}`)
        .then((response) => {
          commit('REMOVE_LESSON', lesson.id)
          // dispatch('fetchModules', lesson.courseId)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  // fetch modules
  fetchModules({ commit }, courseId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/courses/admin/lessons/all/${courseId}`)
        .then((response) => {
          console.log('modules from db', response.data.data)
          commit('SET_MODULES', response.data.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  // fetch modules
  fetchStorageDetails({ _commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/admin/storage/details`)
        .then((response) => {
          // console.log('course config from db', response.data.data)
          resolve(response.data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }
}
